<template>
  <div v-if="tags && tags.length > 0" class="flex items-start gap-1 mt-2">
    <!-- style.css 의 .flex-1(1 0 auto)은 줄어들지 않으므로 grow + basis-0 사용 -->
    <div
      ref="listRef"
      class="flex flex-wrap gap-1 grow basis-0 min-w-0 overflow-hidden"
      :class="{ 'max-h-5': !isExpanded }"
    >
      <p
        v-for="(tag, idx) in tags"
        :key="idx"
        class="product_sub_tt leading-5"
      >
        {{ tag }}
      </p>
    </div>

    <!-- 한 줄을 넘을 때만 펼치기/접기 버튼 노출 -->
    <button
      v-if="isOverflowing"
      type="button"
      class="shrink-0 flex items-center h-5 px-1 text-neutral-500 hover:text-neutral-900"
      :aria-label="isExpanded ? '태그 접기' : '태그 펼치기'"
      :aria-expanded="isExpanded"
      @click.prevent.stop="isExpanded = !isExpanded"
    >
      <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="transition-transform"
        :class="{ 'rotate-180': isExpanded }"
      >
        <path
          d="M0 0.550314L5 5L10 0.550314L9.37279 0L5 3.89151L0.627209 0L0 0.550314Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, onUnmounted, defineProps } from "vue";

const props = defineProps({
  tags: {
    type: Array,
    default: () => [],
  },
});

const listRef = ref(null);
const isExpanded = ref(false);
const isOverflowing = ref(false);

// 첫 줄(태그 하나) 높이보다 내용이 길면 한 줄을 넘는 것으로 판단 (펼친 상태에서도 같은 기준)
const checkOverflow = () => {
  const el = listRef.value;
  if (!el?.firstElementChild) return;
  isOverflowing.value = el.scrollHeight > el.firstElementChild.offsetHeight + 1;
};

// 카드 폭이 바뀌면 줄 수가 달라지므로 다시 판단
const resizeObserver = new ResizeObserver(checkOverflow);

watch(listRef, (el, prevEl) => {
  if (prevEl) resizeObserver.unobserve(prevEl);
  if (el) resizeObserver.observe(el);
});

watch(
  () => props.tags,
  () => nextTick(checkOverflow),
  { deep: true },
);

onUnmounted(() => resizeObserver.disconnect());
</script>
